import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { coursesProgressApi } from "./course-progress.api";
import { CourseProgress } from "../../pages/Analytics/schema/course-progress";

interface CourseProgressState {
	list: CourseProgress[];
}

// A run's PINs are not kept here: they come from GET course-progress/:id/invite-codes, so they
// are on every device and belong to the run shown (BCM360-350). Browsers that ran the old code
// still hold them under this key; drop it.
try {
	localStorage.removeItem("scenario_codes");
} catch {
	// storage unavailable — nothing to clean up
}

const initialState: CourseProgressState = {
	list: [],
};

export const courseProgressSlice = createSlice({
	name: "courses-progress",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			coursesProgressApi.endpoints.getCourseProgresses.matchFulfilled,
			(state, { payload }) => {
				state.list = payload.data;
			}
		);
	},
});

export const coursesProgressReducer = courseProgressSlice.reducer;
export const coursesProgressSelector = (state: RootState) => state[courseProgressSlice.name].list;
